import 'css-chunksrc/client/scenes/constrainElement/constrainedElement/element/event/styles.scss';export default {
  "event": "_event_1v3ey_1",
  "element": "_element_1v3ey_7",
  "icon": "_icon_1v3ey_12"
};